// @flow
import * as React from 'react';
import Modal from 'react-modal';

import { withRouter } from 'app/context/Router';
import AdminAutoMessagesContainer from './AdminAutoMessagesContainer';
import AdminAutoMessagesView from './AdminAutoMessagesView';
import AdminNewAutoMessageModal from 'admin/components/AdminNewAutoMessage';
import EventTracking from 'lib/EventTracking';

type Props = {
  viewingOrgUuid: string,
  params: {
    groupCode: string,
  },
};

type State = {
  isNewAutoMessageDialogOpened: boolean,
};

class AdminAutoMessages extends React.Component<Props, State> {
  state = {
    isNewAutoMessageDialogOpened: false,
  };

  componentDidMount() {
    EventTracking.trackKey('auto_messaging.view_messages.view');
  }

  toggleNewAutoMessageDialog = () => {
    this.setState({ isNewAutoMessageDialogOpened: !this.state.isNewAutoMessageDialogOpened });
  };

  render() {
    const {
      viewingOrgUuid,
      params: { groupCode },
    } = this.props;
    const urlSlug = `/classes/${groupCode}/settings/organization/auto_messages`;

    return (
      <React.Fragment>
        <Modal isOpen={this.state.isNewAutoMessageDialogOpened}>
          <AdminNewAutoMessageModal
            onBack={this.toggleNewAutoMessageDialog}
            viewingOrgUuid={viewingOrgUuid}
          />
        </Modal>
        <AdminAutoMessagesContainer viewingOrgUuid={viewingOrgUuid}>
          {props => (
            <AdminAutoMessagesView
              {...props}
              onClickNewAutoMessage={this.toggleNewAutoMessageDialog}
              urlSlug={urlSlug}
            />
          )}
        </AdminAutoMessagesContainer>
      </React.Fragment>
    );
  }
}

export default withRouter(AdminAutoMessages);
